export default {
  public: {
    loading: "로딩 중...",
    ok: "확인",
    cancel: "취소",
    back: "뒤로",
    userDefined: "사용자 정의",
    edit: "편집",
    clear: "지우기",
    delete: "삭제",
    close: "닫기",
    remove: "제거",
    preView: "미리 보기",
    replace: "교체",
    systemMsg: "시스템 메시지",
    generateSuccess: "PPT 프레젠테이션이 성공적으로 생성되었습니다!",
    templateChoose: "템플릿을 선택하여 AI 생성 완료",
    templateChooseShort: "템플릿 선택",
    templateChangeTips:
      "템플릿 데이터를 교체하면 원래 내용으로 복원됩니다. 수정된 내용은 손실됩니다. 계속하시겠습니까?",
    sourceInvalid: "데이터 소스가 유효하지 않습니다. 다시 시도해 주세요.",
    systemBusy: "서버가 바쁩니다. 페이지를 새로고침해 주세요.",
    templateReplaceSuccess:
      "템플릿 교체가 성공했습니다. 수동으로 저장해 주세요. 시스템은 자동으로 저장하지 않습니다.",
    shareLinkTips: "복사 성공! 웹 페이지로 리디렉션 중입니다!",
    noPermissionTips:
      "죄송합니다. 이 PPT의 공유 권한이 작성자에 의해 닫혔습니다. aippttv에 로그인하여 상상력을 발휘하고 자신의 PPT를 만들어 보세요!",
    copyTips: "복사 성공!",
    loginTips: "먼저 로그인해 주세요!",
    bottomTag: "{brand}로 제작됨",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "글꼴",
      sysFont: "시스템 글꼴",
      lineFont: "온라인 글꼴",
      fontColor: "글자 색상",
      textColor: "글꼴 색상",
      fontDelay: "글꼴 강조",
      addSize: "글꼴 크기 증가",
      duceSize: "글꼴 크기 감소",
      left: "왼쪽 정렬",
      middle: "가운데 정렬",
      horizontalCenter: "수평 가운데",
      verticalCenter: "수직 가운데",
      right: "오른쪽 정렬",
      bottom: "아래쪽 정렬",
      top: "위쪽 정렬",
      bold: "굵게",
      em: "기울임",
      underline: "밑줄",
      strikethrough: "취소선",
      richText: "서식 지우기",
      textFormat: "서식 복사",
      addIndex: "들여쓰기 증가",
      duceIndex: "들여쓰기 감소",
      no: "번호 매기기",
      link: "하이퍼링크",
      inputLink: "하이퍼링크 입력",
      superscript: "위 첨자",
      subscript: "아래 첨자",
      code: "인라인 코드",
      blockquote: "인용",
      horizontal: "수평",
      vertical: "수직",
      width: "너비",
      height: "높이",
      rotate: "회전",
      uniformHorizontal: "수평 균등 분배",
      uniformVertical: "수직 균등 분배",
      combine: "그룹화",
      unCombine: "그룹 해제",
      bgColor: "배경 색상",
      mainColor: "테마 색상",
      useMainToAll: "모두에 테마 적용",
      preMain: "미리 정의된 테마",
    },
    specialEffects: {
      useAll: "모두 적용",
      no: "없음",
      fade: "페이드 인/아웃",
      slideX: "좌/우 슬라이드",
      slideY: "상/하 슬라이드",
    },
  },
  chart: {
    insertCol: "열 삽입",
    insertRow: "행 삽입",
    delCol: "열 삭제",
    delRow: "행 삭제",
    merCell: "셀 병합",
    unMerCell: "셀 병합 해제",
    selectCurrentCol: "현재 열 선택",
    selectCurrentRow: "현재 행 선택",
    selectAll: "모든 셀 선택",
    toTheLeft: "왼쪽으로",
    toTheRight: "오른쪽으로",
    toTheTop: "위로",
    toTheBottom: "아래로",
  },
  desktop: {
    fileExportSuccess: "파일이 성공적으로 내보내졌습니다. 저장 위치를 선택하세요.",
    unSupportPreviewPDF:
      "여기서는 PDF 미리 보기를 사용할 수 없습니다. 미리 보려면 PC 공식 웹사이트로 이동해 주세요.",
  },
  extension: {
    nonsupportDownloadPDF:
      "브라우저 플러그인은 PDF 다운로드를 지원하지 않습니다. 공식 웹사이트에서 다운로드해 주세요.",
  },
  index: {
    createText: "PPT 내용 생성 중",
    createPage: "페이지 {0} 내용 생성 중",
    haveProblem: "문제가 있습니다",
    systemError: "{0}",
    saveText: "성공적으로 저장됨",
    saveMessage: "저장하시겠습니까?",
    cBtn: "취소",
    sBtn: "확인",
    waitMsg:
      "30-40초 동안 기다려 주세요. 생성되지 않으면 브라우저를 새로고침하고 다시 시도해 주세요!",
  },
  errorCode: {
    "401": "인증 실패, 시스템 리소스에 액세스할 수 없음",
    "403": "현재 작업이 허용되지 않음",
    "404": "리소스를 찾을 수 없음",
    default: "알 수 없는 시스템 오류, 관리자에게 보고해 주세요",
    notReDo: "데이터 처리 중입니다. 다시 제출하지 마세요.",
    loginMsg: "세션이 유효하지 않거나 만료되었습니다. 다시 로그인해 주세요.",
    errMsg: "시스템이 바쁩니다. 나중에 다시 시도해 주세요.",
  },
  linkHandler: {
    pptPage: "슬라이드 페이지",
    change: "변경",
    remove: "제거",
  },
  editor: {
    ctrlV: "붙여넣기",
    ctrlA: "모두 선택",
    enter: "새 페이지",
    f5: "슬라이드 쇼",
    delete: "페이지 삭제",
    ctrlD: "페이지 복제",
    ctrlX: "잘라내기",
    ctrlC: "복사",
    shiftF5: "현재 위치에서 시작",
    positionPanel: {
      horizontalCenter: "수평 가운데",
      verticalCenter: "수직 가운데",
      horizontalVerticalCenter: "수평 및 수직 가운데",
      left: "왼쪽 정렬",
      right: "오른쪽 정렬",
      top: "위쪽 정렬",
      bottom: "아래쪽 정렬",
      onTop: "맨 앞으로",
      onBottom: "맨 뒤로",
      levelUp: "한 단계 앞으로",
      levelDown: "한 단계 뒤로",
      setLink: "링크 설정",
      ungroup: "그룹 해제",
      group: "그룹화",
      selectAll: "모두 선택",
      lock: "잠금",
      unlock: "잠금 해제",
      delete: "삭제",
    },
    canvas: {
      index: {
        ctrlR: "눈금자",
        ctrlW: "격자선",
        nl: "없음",
        small: "작게",
        middle: "중간",
        big: "크게",
        closePan: "선택 패널 닫기",
        openPan: "선택 패널 열기",
        reCurrentPage: "현재 페이지 재설정",
        showPpt: "슬라이드 쇼",
        generate: "생성 중...",
      },
      linkDialog: {
        url: "웹 링크 주소 입력",
        ppt: "슬라이드",
        preView: "미리 보기",
        pageUrl: "웹 링크",
        pptPage: "슬라이드 페이지",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "실행 취소",
        reSet: "다시 실행",
        text: "텍스트 삽입",
        horizontal: "수평 텍스트 상자",
        vertical: "수직 텍스트 상자",
        image: "이미지 삽입",
        shape: "도형 삽입",
        line: "선 삽입",
        chart: "차트 삽입",
        table: "표 삽입",
        gs: "수식 삽입",
        voice: "오디오/비디오 삽입",
        screen: "화면에 맞추기",
        workspase: "작업 공간",
        save: "저장",
        logo: "로고 삽입",
        close: "PPT 닫기",
        share: "공유",
        download: "다운로드",
        templateReplacement: "템플릿 교체",
      },
      mediaInput: {
        videoUrl: "비디오 URL 입력, 예: https://xxx.mp4",
        voiceUrl: "오디오 URL 입력, 예: https://xxx.mp3",
        video: "비디오",
        voice: "오디오",
        videoError: "먼저 올바른 비디오 URL을 입력해 주세요",
        voiceError: "먼저 올바른 오디오 URL을 입력해 주세요",
      },
      tableGenerator: {
        table: "표",
        row: "행",
        column: "열",
        rcError: "행/열은 0에서 20 사이여야 합니다!",
      },
      logo: {
        text1: "회사 로고 업로드",
        text2: "회사 이름 입력",
        companyNamePlaceholder: "회사 이름 입력",
        single: "단일 페이지 적용",
        all: "모든 페이지 적용",
        position: "위치",
      },
    },
    editorHeader: {
      index: {
        file: "파일",
        importPptistFile: "pptist 파일 가져오기",
        importPptxFile: "pptx 파일 가져오기",
        exportPptxFile: "파일 내보내기",
        undo: "실행 취소",
        redo: "다시 실행",
        createSlide: "페이지 추가",
        deleteSlide: "페이지 삭제",
        closeGridLines: "격자선 닫기",
        openGridLines: "격자선 열기",
        closeRuler: "눈금자 닫기",
        openRuler: "눈금자 열기",
        resetSlides: "슬라이드 재설정",
        closeSelectPanel: "선택 패널 닫기",
        openSelectPanel: "선택 패널 열기",
        f5: "프레젠테이션",
        enterScreeningFromStart: "처음부터 시작",
        enterScreening: "현재 페이지에서 시작",
        help: "도움말",
        hotkey: "단축키",
        pptShow: "슬라이드 쇼",
        export: "내보내기",
        importing: "가져오는 중...",
        continue: "계속",
        pauseGeneration: "일시 정지",
        noPricing: "회원이 되어 다운로드 권한을 즐기세요.",
        noPricingToOpt: "모든 권한을 잠금 해제하세요.",
        getTokens: "프로로 업그레이드",
        pptSlidesMsg: "{0}개의 완성된 PPT 슬라이드를 생성했습니다! ",
        Feedback: "AI를 작업 도우미로 사용하세요.",
        giveAway: "쿠폰 증정(30분 유효)",
        getItNow: "지금 받기",
        unlockAllPpt: "모든 PPT 기능 잠금 해제",
        grantPermission: "AI 마인드 맵 사용 권한 부여",
        grantPermissionToUseGpt: "GPT 사용 권한 부여",
        permissionCodeUse:
          "할인 코드를 기억하고 결제 웹페이지에서 사용해 주세요!",
        pptTi1: "모든 작업을 완료하고 총 {0}페이지의 ppt를 생성했습니다. ",
        pptTi2: "마지막 단계만 남았습니다. 멋진 AI 작품을 받아보세요!",
      },
    },
    exportDialog: {
      tips: "현재 앱에서는 PPT 다운로드를 지원하지 않습니다. PC에서 다운로드해 주세요.",
      exportScope: "내보내기 범위",
      close: "닫기",
      all: "모두",
      thisPage: "현재",
      auto: "사용자 정의",
      autoScope: "사용자 정의 범위",
      exporting: "내보내는 중...",
      exportImg: "이미지 내보내기",
      expPdf: "인쇄 / PDF 내보내기",
      expPptx: "PPTX 내보내기",
      downloadSuccess: "파일 변환이 성공했습니다. 저장 경로를 선택하세요.",
      exportImage: {
        exportType: "내보내기 형식",
        imageQuality: "이미지 품질",
        ignoreFont: "온라인 글꼴 무시",
        ignoreLineFont:
          "기본적으로 내보내기 시 온라인 글꼴은 무시됩니다. 프레젠테이션에서 온라인 글꼴을 사용했고 내보낸 후에도 스타일을 유지하려면 '온라인 글꼴 무시' 옵션을 끄면 됩니다. 하지만 이는 내보내기 시간을 증가시킬 수 있습니다.",
      },
      exportPdf: {
        all: "모든 슬라이드",
        thisPage: "현재 슬라이드",
        pageNum: "시트당 페이지 수",
        white: "여백",
        notice:
          "참고: 인쇄 미리 보기가 실제 스타일과 일치하지 않으면 팝업 인쇄 창에서 '배경 그래픽' 옵션을 확인하세요.",
      },
      exportPPTX: {
        title: "기본 마스터 재정의",
        notice:
          "참고: 다운로드 후 Microsoft Office로 열어 주세요. 다른 프로그램은 호환되지 않을 수 있습니다.",
      },
    },
    remark: {
      remark: "발표자 노트 입력",
    },
    thumbnails: {
      add: "슬라이드 추가",
      slide: "슬라이드",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "색상 변경 (마스크)",
          maskColor: "마스크 색상",
          opacity: "불투명도",
        },
        elementFilter: {
          enableFilter: "필터 활성화",
          blur: "흐림",
          brightness: "밝기",
          contrast: "대비",
          grayscale: "회색조",
          saturate: "채도",
          hueRotate: "색조 회전",
          opacity: "불투명도",
        },
        elementFlip: {
          horizontal: "수평 뒤집기",
          vertical: "수직 뒤집기",
        },
        elementOpacity: {
          opacity: "불투명도",
        },
        elementOutline: {
          border: "테두리 활성화",
          borderStyle: "테두리 스타일",
          solid: "실선 테두리",
          dashes: "점선 테두리",
          borderColor: "테두리 색상",
          borderWeight: "테두리 두께",
        },
        elementShadow: {
          enable: "그림자 활성화",
          horizontal: "수평 그림자",
          vertical: "수직 그림자",
          fuzzyDistance: "흐림 거리",
          color: "그림자 색상",
        },
      },
      panel: {
        background: "배경 채우기",
        solid: "단색 채우기",
        image: "이미지 채우기",
        gradient: "그라데이션 채우기",
        contain: "맞추기",
        repeat: "타일",
        cover: "채우기",
        linear: "선형 그라데이션",
        radial: "방사형 그라데이션",
        startColor: "시작 색상",
        endColor: "종료 색상",
        rotate: "그라데이션 각도",
        useBackgroundToAll: "모두에 배경 적용",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "범주",
            colType: "시리즈",
          },
          index: {
            edit: "차트 데이터 편집",
            area: "영역 차트 스타일",
            line: "산점도 스타일",
            lineSmooth: "부드러운 선 사용",
            horizontalBars: "막대 차트 스타일",
            stackBars: "누적 스타일",
            donut: "도넛 차트 스타일",
            img: "범례",
            hidden: "숨기기",
            showTop: "위쪽에 표시",
            showBottom: "아래쪽에 표시",
            tabColor: "격자 색상",
            labelColor: "글꼴 색상",
            titleSetColor: "테마 색상:",
            title: "추천 테마",
            titleColor: "테마 색상 추가",
          },
        },
        audioStylePanel: {
          imgColor: "아이콘 색상",
          autoPlay: "자동 재생",
          loopPlay: "반복 재생",
        },
        imageStylePanel: {
          cutImg: "이미지 자르기",
          shape: "도형으로",
          type: "범주",
          preview: "미리 보기",
          use: "사용",
          searchByType: "범주로 검색",
          uploadAndReplace: "이미지 업로드 및 교체",
          reSetStyle: "스타일 재설정",
          setBackground: "배경으로 설정",
          clip1: "종횡비로 (정사각형)",
          clip2: "종횡비로 (세로)",
          clip3: "종횡비로 (가로)",
        },
        latexStylePanel: {
          edit: "LaTeX 편집",
          color: "색상",
          bold: "굵게",
        },
        lineStylePanel: {
          style: "선 스타일",
          solid: "실선",
          dotted: "점선",
          color: "선 색상",
          weight: "선 두께",
          startStyle: "시작 스타일",
          endStyle: "종료 스타일",
          none: "없음",
          arrow: "화살표",
          dot: "점",
        },
        multiStylePanel: {
          colorPicker: "채우기 색상",
          style: "테두리 스타일",
          solid: "실선 테두리",
          dotted: "점선 테두리",
          color: "테두리 색상",
          weight: "테두리 두께",
        },
        shapeStylePanel: {
          replaceShade: "도형 교체를 클릭하세요",
          fill: "단색 채우기",
          gradient: "그라데이션 채우기",
          linear: "선형 그라데이션",
          radial: "방사형 그라데이션",
        },
        tableStylePanel: {
          colFull: "셀 채우기",
          row: "행",
          col: "열",
          titleRow: "제목 행",
          totalRow: "총계 행",
          firstCol: "첫 번째 열",
          lastCol: "마지막 열",
          titleColor: "테마 색상",
          themeTable: "테마 표",
        },
        textStylePanel: {
          urlError: "올바른 웹 링크 주소가 아닙니다",
          command: "글머리 기호 목록",
          lineHeight: "줄 간격",
          times: "배수",
          paragraphSpace: "단락 간격",
          wordSpace: "단어 간격",
          textIndent: "첫 줄 들여쓰기",
          textFill: "텍스트 상자 채우기",
          title: "제목",
          titleSmall: "부제목",
          text: "텍스트",
          textSmall: "텍스트 [작게]",
          zs1: "참고 1",
          zs2: "참고 2",
        },
        videoStylePanel: {
          cover: "비디오 미리 보기 커버",
          recover: "커버 재설정",
        },
      },
      elementAnimationPanel: {
        addEffects: "애니메이션 추가",
        selectAndAddEffects: "캔버스에서 요소를 선택하고 애니메이션 추가",
        time: "지속 시간",
        triggerType: "트리거 유형",
        initiative: "수동 트리거",
        sameTime: "이전과 동시에",
        after: "이전 이후",
        change: "애니메이션 변경",
        in: "진입",
        out: "퇴장",
        attention: "강조",
      },
      elementPositionPanel: {
        layer: "레이어",
        align: "정렬",
        top: "맨 앞으로",
        bottom: "맨 뒤로",
        up: "앞으로",
        down: "뒤로",
        noRixedRatio: "종횡비 잠금 해제",
        fixedRatio: "종횡비 잠금",
      },
      index: {
        style: "스타일",
        symbol: "기호",
        position: "위치",
        animation: "애니메이션",
        design: "디자인",
        slideAnimation: "전환",
      },
      slideDesignPanel: {
        canvasSize: "캔버스 크기",
        wideScreen1: "와이드스크린 16:9",
        wideScreen2: "와이드스크린 16:10",
        standard: "표준 4:3",
        paper: "A3 / A4 용지",
        title: "전역 테마",
        mainColor: "테마 색상",
        useMainToAll: "모두에 테마 적용",
        preMain: "미리 정의된 테마",
        text: "텍스트 Aa",
        use: "적용",
        useToAll: "모두 적용",
      },
    },
    selectPanel: {
      select: "선택",
      showAll: "모두 표시",
      hideAll: "모두 숨기기",
      group: "그룹화",
    },
    redraw: {
      topLabel: "다시 그리기",
      msgTips: "생성할 내용 입력",
      retext: "다시 그리기",
      cltext: "취소",
      btnText: "생성",
      reConfirm:
        "생성하면 현재 페이지가 교체되고 이전 내용은 저장되지 않습니다. 계속하시겠습니까?",
      confirmBtnTxt: "계속",
    },
  },
  screen: {
    presenter: {
      normalView: "일반 보기",
      pen: "펜",
      laserPointer: "레이저 포인터",
      timer: "타이머",
      exitFullScreen: "전체 화면 종료",
      fullScreen: "전체 화면",
      endPresentation: "프레젠테이션 종료",
      speakerNotes: "발표자 노트",
      speakersView: "발표자 보기",
      previousPage: "이전 페이지",
      nextPage: "다음 페이지",
      firstPage: "첫 페이지",
      lastPage: "마지막 페이지",
      brushTool: "브러시 도구",
      noRemarks: "노트 없음",
      lastPageTips: "이미 마지막 페이지입니다",
      firstPageTips: "이미 첫 페이지입니다",
      autoPlay: "자동 쇼 시작",
    },
    writingBoard: {
      inkThickness: "잉크 두께",
      eraserSize: "지우개 크기",
      eraser: "지우개",
      clearInk: "잉크 지우기",
      blackboard: "칠판",
      closeBrush: "브러시 닫기",
    },
  },
  mobile: {
    index: {
      notSupport: "모바일 버전이 급히 개발 중입니다.",
      toPc: "PC에서 웹사이트를 방문해 주세요.",
      editTips: "PC에서 편집해 주세요.",
    },
  },
  useCreateElement: {
    type: "유형{0}",
    class: "시리즈{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "LaTeX 수식 입력",
        preViw: "수식 미리 보기",
        symbol: "일반 기호",
        formula: "미리 정의된 수식",
        error: "수식은 비워둘 수 없습니다",
      },
    },
    colorPicker: {
      recentUse: "최근 사용",
    },
  },
  config: {
    latex: {
      gauss: "가우스 공식",
      fourierSeries: "푸리에 급수",
      taylorExpansion: "테일러 전개",
      definiteIntegral: "정적분",
      trigonometricIdentity1: "삼각 항등식 1",
      trigonometricIdentity2: "삼각 항등식 2",
      expansion: "합 전개",
      euler: "오일러 공식",
      differential: "베르누이 방정식",
      totalDifferentialEquation: "전미분 방정식",
      homogeneous: "비균질 방정식",
      cauchy: "코시 평균값 정리",
      lagrange: "라그랑주 평균값 정리",
      arcsin: "도함수 공식",
      trigonometric: "삼각 함수 적분",
      quadric: "이차 곡면",
      dx: "2계 미분",
      partial: "방향 도함수",
      operators: "수학",
      group: "조합",
      verbatim: "함수",
      greek: "그리스 문자",
    },
    symbol: {
      letter: "문자",
      number: "숫자",
      math: "수학",
      arrow: "화살표",
      graph: "그래프",
    },
    lines: {
      straight: "직선",
      brokenOrCurve: "꺾이거나 곡선",
    },
  },
  hotkey: {
    opt: {
      common: "일반",
      ctrlX: "잘라내기",
      ctrlC: "복사",
      ctrlV: "붙여넣기",
      ctrlD: "빠른 복사 붙여넣기",
      ctrlA: "모두 선택",
      ctrlZ: "실행 취소",
      ctrlY: "다시 실행",
      del: "삭제",
      ctrlMore: "다중 선택",
      ctrlP: "인쇄",
      esc: "팝업 닫기",
    },
    slide: {
      show: "슬라이드 쇼",
      edit: "슬라이드 편집",
      first: "처음부터 슬라이드 쇼 시작",
      current: "현재 페이지에서 슬라이드 쇼 시작",
      spacePre: "이전 페이지로 전환",
      spaceNext1: "다음 페이지로 전환",
      spaceNext2: "다음 페이지로 전환",
      out: "프레젠테이션 종료",
      new: "새 슬라이드",
      move: "캔버스 이동",
      upOrDown: "캔버스 확대/축소",
      up: "캔버스 확대",
      down: "캔버스 축소",
      screen: "현재 화면에 캔버스 맞추기",
      noSelectPrePage: "이전 페이지 (선택되지 않은 요소)",
      noSelectNextPage: "다음 페이지 (선택되지 않은 요소)",
      prePage: "이전 페이지",
      nextPage: "다음 페이지",
    },
    element: {
      opt: "요소 작업",
      move: "이동",
      lock: "잠금",
      combo: "그룹화",
      cancelCombo: "그룹 해제",
      top: "맨 앞으로",
      bottom: "맨 뒤로",
      h: "종횡비 잠금",
      v: "수평 / 수직 선 생성",
      change: "포커스 요소 전환",
      com: "이미지 자르기 확인",
      text: "텍스트",
      image: "이미지",
      shape: "도형",
      line: "선",
      chart: "차트",
      table: "표",
      video: "비디오",
      audio: "오디오",
      latex: "수식",
    },
    table: {
      edit: "표 편집",
      nextCol: "다음 셀에 포커스",
      insertTop: "위에 행 삽입",
      insertBottom: "아래에 행 삽입",
      insertLeft: "왼쪽에 열 삽입",
      insertRight: "오른쪽에 열 삽입",
    },
    chat: {
      edit: "차트 데이터 편집",
      nextLine: "다음 줄에 포커스",
    },
    text: {
      edit: "텍스트 편집",
      bold: "굵게",
      italics: "기울임",
      underline: "밑줄",
      delLine: "취소선",
    },
  },
  shape: {
    rectangle: "직사각형",
    commonUse: "일반 도형",
    arrow: "화살표",
    other: "기타 도형",
    line: "선",
  },
  animation: {
    in: {
      bounce: "바운스",
      bounceIn: "바운스 인",
      bounceInLeft: "왼쪽 바운스 인",
      bounceInRight: "오른쪽 바운스 인",
      bounceInUp: "위쪽 바운스 인",
      bounceInDown: "아래쪽 바운스 인",
      fade: "페이드",
      fadeIn: "페이드 인",
      fadeInDown: "아래쪽 페이드 인",
      fadeInDownBig: "큰 아래쪽 페이드 인",
      fadeInLeft: "왼쪽 페이드 인",
      fadeInLeftBig: "큰 왼쪽 페이드 인",
      fadeInRight: "오른쪽 페이드 인",
      fadeInRightBig: "큰 오른쪽 페이드 인",
      fadeInUp: "위쪽 페이드 인",
      fadeInUpBig: "큰 위쪽 페이드 인",
      fadeInTopLeft: "왼쪽 상단 페이드 인",
      fadeInTopRight: "오른쪽 상단 페이드 인",
      fadeInBottomLeft: "왼쪽 하단 페이드 인",
      fadeInBottomRight: "오른쪽 하단 페이드 인",
      rotate: "회전",
      rotateIn: "회전 인",
      rotateInDownLeft: "왼쪽 아래 회전 인",
      rotateInDownRight: "오른쪽 아래 회전 인",
      rotateInUpLeft: "왼쪽 위 회전 인",
      rotateInUpRight: "오른쪽 위 회전 인",
      zoom: "확대",
      zoomIn: "확대 인",
      zoomInDown: "아래쪽 확대 인",
      zoomInLeft: "왼쪽 확대 인",
      zoomInRight: "오른쪽 확대 인",
      zoomInUp: "위쪽 확대 인",
      slide: "슬라이드",
      slideInDown: "아래쪽 슬라이드 인",
      slideInLeft: "왼쪽 슬라이드 인",
      slideInRight: "오른쪽 슬라이드 인",
      slideInUp: "위쪽 슬라이드 인",
      flip: "뒤집기",
      flipInX: "X축 뒤집기 인",
      flipInY: "Y축 뒤집기 인",
      back: "뒤로",
      backInDown: "아래쪽 뒤로 인",
      backInLeft: "왼쪽 뒤로 인",
      backInRight: "오른쪽 뒤로 인",
      backInUp: "위쪽 뒤로 인",
      lightSpeed: "빛 속도",
      lightSpeedInRight: "오른쪽 빛 속도 인",
      lightSpeedInLeft: "왼쪽 빛 속도 인",
    },
    out: {
      bounce: "바운스",
      bounceOut: "바운스 아웃",
      bounceOutLeft: "왼쪽 바운스 아웃",
      bounceOutRight: "오른쪽 바운스 아웃",
      bounceOutUp: "위쪽 바운스 아웃",
      bounceOutDown: "아래쪽 바운스 아웃",
      fade: "페이드",
      fadeOut: "페이드 아웃",
      fadeOutDown: "아래쪽 페이드 아웃",
      fadeOutDownBig: "큰 아래쪽 페이드 아웃",
      fadeOutLeft: "왼쪽 페이드 아웃",
      fadeOutLeftBig: "큰 왼쪽 페이드 아웃",
      fadeOutRight: "오른쪽 페이드 아웃",
      fadeOutRightBig: "큰 오른쪽 페이드 아웃",
      fadeOutUp: "위쪽 페이드 아웃",
      fadeOutUpBig: "큰 위쪽 페이드 아웃",
      fadeOutTopLeft: "왼쪽 상단 페이드 아웃",
      fadeOutTopRight: "오른쪽 상단 페이드 아웃",
      fadeOutBottomLeft: "왼쪽 하단 페이드 아웃",
      fadeOutBottomRight: "오른쪽 하단 페이드 아웃",
      rotate: "회전",
      rotateOut: "회전 아웃",
      rotateOutDownLeft: "왼쪽 아래 회전 아웃",
      rotateOutDownRight: "오른쪽 아래 회전 아웃",
      rotateOutUpLeft: "왼쪽 위 회전 아웃",
      rotateOutUpRight: "오른쪽 위 회전 아웃",
      zoom: "확대",
      zoomOut: "확대 아웃",
      zoomOutDown: "아래쪽 확대 아웃",
      zoomOutLeft: "왼쪽 확대 아웃",
      zoomOutRight: "오른쪽 확대 아웃",
      zoomOutUp: "위쪽 확대 아웃",
      slide: "슬라이드",
      slideOutDown: "아래쪽 슬라이드 아웃",
      slideOutLeft: "왼쪽 슬라이드 아웃",
      slideOutRight: "오른쪽 슬라이드 아웃",
      slideOutUp: "위쪽 슬라이드 아웃",
      flip: "뒤집기",
      flipOutX: "X축 뒤집기 아웃",
      flipOutY: "Y축 뒤집기 아웃",
      back: "뒤로",
      backOutDown: "아래쪽 뒤로 아웃",
      backOutLeft: "왼쪽 뒤로 아웃",
      backOutRight: "오른쪽 뒤로 아웃",
      backOutUp: "위쪽 뒤로 아웃",
      lightSpeed: "빛 속도",
      lightSpeedOutRight: "오른쪽 빛 속도 아웃",
      lightSpeedOutLeft: "왼쪽 빛 속도 아웃",
    },
    attention: {
      shake: "흔들기",
      shakeX: "X축 흔들기",
      shakeY: "Y축 흔들기",
      headShake: "머리 흔들기",
      swing: "스윙",
      wobble: "흔들림",
      tada: "타다",
      jello: "젤로",
      other: "기타",
      bounce: "바운스",
      flash: "플래시",
      pulse: "펄스",
      rubberBand: "고무 밴드",
      heartBeat: "심장 박동",
    },
  },
  requestError: {
    tokenExpires: "인증 실패, 시스템 리소스에 액세스할 수 없음",
    permissionDenied: "현재 작업이 허용되지 않음",
    notFound: "리소스를 찾을 수 없음",
    default: "알 수 없는 시스템 오류, 관리자에게 보고해 주세요",
    exceptionReminder: "예외 알림",
    pleaseLogin: "세션이 유효하지 않거나 만료되었습니다. 다시 로그인해 주세요.",
    networkError: "네트워크 오류",
    requestTimeOut: "시스템 인터페이스 요청 시간 초과",
    requestFailed: "요청 실패",
  },
  promptsText: {
    theme: [
      "다양한 테마를 탐색하고 끝없는 즐거움을 발견하세요!",
      "각 테마 페이지로 들어가 마법 같은 여행을 시작하세요!",
      "각 테마는 고유한 매력을 가지고 있습니다. 모두 탐험해 보는 건 어떨까요?",
      "테마의 세계에 오신 것을 환영합니다. 관심사를 선택하고 모험을 시작하세요!",
      "첫 번째 AI 슬라이드쇼가 곧 도착합니다. 기대해 주세요!",
      "슬라이드쇼 여행을 시작합니다. 곧 출발합니다...",
      "새로운 시각적 향연을 준비하세요. 슬라이드쇼가 곧 시작됩니다...",
      "꽉 잡으세요! 다음 정류장은 환상적인 슬라이드쇼 여행입니다...",
      "빨리! 눈을 감고 놀라운 슬라이드쇼가 도착하기를 기다리세요...",
      "슬라이드쇼 세계가 곧 펼쳐질 것입니다. 기대해 주세요...",
      "기다려 주세요. 슬라이드쇼의 꿈이 곧 실현될 것입니다...",
    ],
    directory: [
      "디렉토리 페이지에서 필요한 모든 것을 찾으세요!",
      "디렉토리 페이지는 탐색의 보물입니다. 필요한 것을 쉽게 찾을 수 있습니다!",
      "디렉토리 페이지는 포괄적인 탐색 서비스를 제공하여 빠르게 목표를 찾을 수 있습니다!",
      "어디로 가야 할지 모르시나요? 디렉토리 페이지에서 영감과 방향을 찾으세요!",
    ],
    Content: [
      "기다리는 중... 다음 슬라이드는 무지개처럼 화려할 것입니다!",
      "와우! 다음 슬라이드는 불꽃놀이처럼 피어날 것입니다. 놀라움을 준비하세요!",
      "기다림의 마법을 느껴보세요! 다음 슬라이드는 당신의 눈을 밝게 할 것입니다!",
      "기대해 주세요! 다음 슬라이드는 놀라운 시각적 향연을 선사할 것입니다!",
      "빨리! 커튼을 열고 다음 슬라이드의 눈부신 빛을 맞이할 준비를 하세요!",
      "준비하세요! 다음 슬라이드는 새로운 시각적 폭풍을 가져올 것입니다!",
      "당신의 호기심이 곧 충족될 것입니다! 다음 슬라이드는 당신을 놀라게 할 것입니다!",
      "기다리는 중... 다음 슬라이드는 멋진 시각적 여행으로 당신을 안내할 것입니다!",
      "기다릴 수 없나요? 다음 슬라이드는 대단한 축제처럼 흥미진진할 것입니다!",
      "다음 슬라이드는 무엇일까요? 답이 곧 공개됩니다...",
      "안전벨트를 매주세요. 우리는 곧 다음 슬라이드로 날아갈 것입니다...",
      "행복이 다가옵니다! 다음 슬라이드는 당신을 향해 빠르게 달려오고 있습니다...",
      "다음 슬라이드는 무슨 색일까요? 답이 곧 공개됩니다...",
      "와우! 다음 슬라이드는 당신에게 예상치 못한 놀라움을 선사할 것입니다...",
      "시도해 보고 싶나요? 다음 슬라이드는 당신의 호기심을 충족시켜 줄 것입니다...",
      "기다리는 중... 다음 슬라이드는 당신에게 기쁨과 놀라움을 선사할 것입니다...",
      "기다리는 중... 맛있는 커피를 기다리는 것처럼 다음 슬라이드는 당신의 기분을 즐겁게 할 것입니다!",
      "눈을 감고 3을 세세요. 다음 슬라이드는 놀라움을 선사할 것입니다! 1... 2... 3...",
      "모험 중! 다음 슬라이드를 기다리는 것은 보물을 발견하는 것만큼 흥미진진합니다!",
      "준비되셨나요? 다음 슬라이드는 멋진 모험으로 당신을 안내할 것입니다!",
    ],
    Comprehensive: [
      "조금씩, 끝없는 재미의 세계를 탐험하세요!",
      "테마에서 디렉토리, 그리고 콘텐츠 페이지까지, 모든 단계는 발견의 여정입니다!",
      "함께 멋진 여행을 떠나 이 흥미진진한 세계에 우리의 흔적을 남겨보아요!",
      "이 놀라운 웹사이트에서 함께 더 많은 것을 발견해 보아요!",
    ],
    Unpurchased: [
      "시도해 보고 싶나요? 다음 슬라이드는 시각적 향연의 시작입니다. 함께하세요!",
      "제품 이상의 가치, 삶의 방식입니다! 구매를 클릭하고 기분을 날려보세요!",
      "여기서 당신은 제품뿐만 아니라 풍부한 행복도 구매합니다!",
      "회원으로 가입하고 즐거운 삶의 새로운 장을 시작하세요!",
      "구매를 클릭하고 매일을 놀라움과 즐거움으로 가득 채우세요!",
      "구매는 행동 이상의 의미, 삶을 즐기는 방법입니다!",
      "기회를 잡고 원하는 제품을 구매하여 삶을 더욱 다채롭게 만드세요!",
      "구매는 멋진 모험입니다. 함께 이 여정을 시작해 보아요!",
      "구매를 클릭하고 자신에게 놀라움과 행복을 선사하세요!",
      "구매는 표현입니다. 함께 마음으로 선택해 보아요!",
    ],
  },
};